/** @license ISC License (c) copyright 2019 original and current authors */
/** @author Dale Francis (dalefrancis88) */

// isFalsy : a -> Boolean
function isFalsy(x) {
  return !x
}

module.exports = isFalsy
